import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";
import { errMsg } from "@/lib/api";

export const ConfirmDialog = ({ open, onClose, onConfirm, title, description, confirmLabel = "Confirm", testId }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => { if (open) setError(""); }, [open]);
  const confirm = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { await onConfirm(); onClose(); } catch (err) { setError(errMsg(err)); }
    finally { setBusy(false); }
  };
  return <AlertDialog open={open} onOpenChange={(v) => !v && !busy && onClose()}>
    <AlertDialogContent data-testid={`${testId}-dialog`}>
      <AlertDialogHeader>
        <div className="w-11 h-11 rounded-full bg-red-50 text-red-800 grid place-items-center mb-1" aria-hidden="true"><AlertTriangle className="w-6 h-6" /></div>
        <AlertDialogTitle data-testid={`${testId}-title`}>{title}</AlertDialogTitle>
        <AlertDialogDescription data-testid={`${testId}-description`}>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      {error && <p role="alert" className="rounded-md border border-red-200 bg-red-50 text-red-900 p-3 text-sm" data-testid={`${testId}-error`}>{error}</p>}
      <AlertDialogFooter>
        <AlertDialogCancel disabled={busy} data-testid={`${testId}-cancel`}>Cancel</AlertDialogCancel>
        <AlertDialogAction disabled={busy} onClick={confirm} className="bg-[#E60000] hover:bg-[#CC0000] text-white" data-testid={`${testId}-confirm`}>{busy ? "Please wait…" : confirmLabel}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>;
};
